/**
 * 工具类
 */
import { JSEncrypt } from 'jsencrypt'

export default {
  getUrlParam (name) {
    const params = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href)
    return params !== null ? params[1] : null
  },
  formatDateToString (date) {
    if (date === undefined || date === null) {
      return null
    }
    if (typeof date === 'string') {
      return date
    }
    if (!(date instanceof Date)) {
      return null
    }
    const dateStr = date.toString()
    const array = dateStr.split(' ')
    // array[0]为周几 array[1]为月份 array[2]为日 array[3]为年 array[4]为时分秒hh:mm:ss array[5]为时区
    let curDateTime = array[3]
    switch (array[1]) {
      case 'Jan':
        curDateTime += '-01'
        break
      case 'Feb':
        curDateTime += '-02'
        break
      case 'Mar':
        curDateTime += '-03'
        break
      case 'Apr':
        curDateTime += '-04'
        break
      case 'May':
        curDateTime += '-05'
        break
      case 'Jun':
        curDateTime += '-06'
        break
      case 'Jul':
        curDateTime += '-07'
        break
      case 'Aug':
        curDateTime += '-08'
        break
      case 'Sep':
        curDateTime += '-09'
        break
      case 'Oct':
        curDateTime += '-10'
        break
      case 'Nov':
        curDateTime += '-11'
        break
      case 'Dec':
        curDateTime += '-12'
        break
      default:
        break
    }
    curDateTime += '-' + array[2] + ' ' + array[4]
    return curDateTime
  },
  getUUID () {
    var d = new Date().getTime()
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16)
    })
    return uuid
  },
  encryptByPublicKey (content) {
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey('MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAIADRdny8vRYa6TSegI/5jUCPXwczjmw6VWahVkPhIyYPNLDvRY4qpRSMdv/OeLGVRJ5WhNDosY8Oab9cRwW58cCAwEAAQ==')
    return encrypt.encrypt(content)
  }
}
